import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import camelCaseRecursive from 'camelcase-keys-recursive';
import { useAbility } from '@casl/react';
import { AbilityContext } from '../../../config/abilityContext';
import { fetchOvertimeCompensationRequests } from '../../../requests/overtimeCompensations';
import { ComponentDataTable, DefaultModal, FormikSelect, SimpleCenteredModal } from '../../../components';
import columns from './StyledColumns';
import OvertimeCompensationInfoTable from './OvertimeCompensationInfoTable';
import OvertimeCompensationShow from './OvertimeCompensationShow';

const OvertimeCompensationProfileDatatableStyled = ({
  currentEmployee,
  defaultStatus = '0',
  employeesBelongBoss,
  moreData,
  setMoreData
}) => {
  const ability = useAbility(AbilityContext);
  const dispatch = useDispatch();

  const [status, setStatus] = useState(defaultStatus);
  const [amount, setAmount] = useState(0);
  const [requests, setRequests] = useState([]);
  const [onRequest, setOnRequest] = useState(true);

  const [modalTitle, setModalTitle] = useState('');
  const [modalBody, setModalBody] = useState('');
  const [modalShow, setModalShow] = useState(false);
  const [defaultModalBody, setDefaultModalBody] = useState('');
  const [defaultModalSize, setDefaultModalSize] = useState('lg');
  const [firstModalShow, setFirstModalShow] = useState(false);
  const [defaultModalButtons, setDefaultModalButtons] = useState(true);

  const compensationStatus = [
    { label: 'Todos', value: '' },
    { label: 'Aprobado', value: '1' },
    { label: 'Pendiente', value: '0' },
    { label: 'Rechazado', value: '2' }
  ];

  const handleSuccessIndex = response => {
    const { data, metadata } = response.data;
    setRequests(data);
    setAmount(metadata.amount);
    setOnRequest(false);
  };

  const handleCustomParams = () => {
    if (status !== '0' && employeesBelongBoss.length > 0) {
      return {
        filter_employee: employeesBelongBoss
      };
    }
    return {
      pending_review: currentEmployee
    };
  };

  const handleIndexRequest = async params => {
    const customParams = handleCustomParams(status);
    setOnRequest(true);
    const sendParams = {
      ...customParams,
      ...params,
      status
    };
    fetchOvertimeCompensationRequests({ dispatch, params: sendParams, successCallback: handleSuccessIndex });
  };

  const handleDefaultModalClose = () => {
    setFirstModalShow(false);
  };

  const handleManageRequest = item => {
    setDefaultModalBody(
      <OvertimeCompensationInfoTable
        item={item}
        currentEmployee={currentEmployee}
        setModalShow={setFirstModalShow}
        moreData={moreData}
        setMoreData={setMoreData}
      />
    );
    setDefaultModalButtons(false);
    setFirstModalShow(true);
    setDefaultModalSize('xl');
  };

  const handleActions = (item, action) => {
    switch (action) {
      case 'actions':
        handleManageRequest(camelCaseRecursive(item));
        break;
      case 'show':
        setModalTitle('Solicitud de Días por HH.EE');
        setModalBody(<OvertimeCompensationShow item={item} />);
        setModalShow(true);
        break;
      default:
        // eslint-disable-next-line no-console
        console.log('Error: Action not found');
        break;
    }
  };

  const sortColumnCase = name => {
    switch (name) {
      case 'employee' || 'employee.full_name':
        return { sort_employees: name };
      case 'status':
        return { sort_status: name };
      default:
        return { sort_column: name };
    }
  };

  return (
    <>
      <ComponentDataTable
        columns={columns(handleActions, ability)}
        data={requests}
        handleSortCase={sortColumnCase}
        customHeaderCenter={
          <FormikSelect
            options={compensationStatus}
            label=""
            value={status}
            defaultValue={status}
            onChange={data => {
              setStatus(data ? data.value : '');
              setOnRequest(true);
              setMoreData(!moreData);
            }}
            placeholder="Todos"
          />
        }
        moreData={moreData}
        nameRangePicker="filter_dates"
        onRowClicked={item => handleActions(item, 'show')}
        onRequest={onRequest}
        rangePicker
        resourceRequest={handleIndexRequest}
        totalRows={amount}
        withEndDate
        withStartDate
      />
      <SimpleCenteredModal
        size="md"
        title={modalTitle}
        body={modalBody}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
      <DefaultModal
        body={defaultModalBody}
        disabled={onRequest}
        title=""
        handleClose={handleDefaultModalClose}
        modalSize={defaultModalSize}
        show={firstModalShow}
        withClose={defaultModalButtons}
        withConfirm={defaultModalButtons}
      />
    </>
  );
};

export default OvertimeCompensationProfileDatatableStyled;
